import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function TruthSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-429">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gold/30" data-id="element-430"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-431">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-432">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-10" data-id="element-433">
            {t('truth', 'title')}
          </h2>

          <div className="space-y-8 text-lg text-dark/80" data-id="element-434">
            <p data-id="element-435">{t('truth', 'loseMoney')}</p>
            <p className="text-2xl font-serif text-gold-dark font-medium" data-id="element-436">
              {t('truth', 'loseConfidence')}
            </p>
            <p data-id="element-437">{t('truth', 'believe')}</p>
            <p className="italic" data-id="element-438">{t('truth', 'accept')}</p>
            <div className="py-6" data-id="element-439">
              <p className="text-2xl font-bold text-dark uppercase tracking-wider" data-id="element-440">
                {t('truth', 'lie')}
              </p>
            </div>
            <p className="font-medium" data-id="element-441">{t('truth', 'soldLie')}</p>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gold/30" data-id="element-442"></div>
    </section>;
}